import { Grid, Heading, List, ListItem, ListIcon, Text } from '@chakra-ui/react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import CheckMarkIcon from '@/assets/icons/ic-check-mark.svg';

export const LibrariansSubscription: FC = () => {
  const { t } = useTranslation();

  return (
    <Grid my={{ base: 16, lg: 24 }} templateColumns={{ base: '1fr', lg: '1fr 1fr' }} gap={{ base: 0, lg: 14 }}>
      <Heading fontSize={{ base: '32px', lg: '48px' }} lineHeight={{ base: 10, lg: '60px' }}>
        {t('librarians.subscription.title')}
      </Heading>
      <List pt={{ base: 14, md: 20, lg: 4 }} spacing={12}>
        <ListItem fontSize="xl" display="flex">
          <ListIcon as={CheckMarkIcon} bg="violet.500" color="white" w="26px" h="26px" borderRadius={20} mr={5} />
          <Text>{t('librarians.subscription.specifications.0')}</Text>
        </ListItem>
        <ListItem fontSize="xl" display="flex">
          <ListIcon as={CheckMarkIcon} bg="violet.500" color="white" w="26px" h="26px" borderRadius={20} mr={5} />
          <Text>{t('librarians.subscription.specifications.1')}</Text>
        </ListItem>
        <ListItem fontSize="xl" display="flex">
          <ListIcon as={CheckMarkIcon} bg="violet.500" color="white" w="26px" h="26px" borderRadius={20} mr={5} />
          <Text>{t('librarians.subscription.specifications.2')}</Text>
        </ListItem>
        <ListItem fontSize="xl" display="flex">
          <ListIcon as={CheckMarkIcon} bg="violet.500" color="white" w="26px" h="26px" borderRadius={20} mr={5} />
          <Text>{t('librarians.subscription.specifications.3')}</Text>
        </ListItem>
      </List>
    </Grid>
  );
};
